import React, { useState, useEffect } from 'react'
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';

const HotelUsers = ({product}) => {
const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [acType, setAcType] = useState('Yes');
         const [loading, setLoading] = useState(false);
         const [showModal, setShowModal] = useState(false);
         const [selectedUser, setSelectedUser] = useState('');


  useEffect(() => {

    fetchUsers();
  }, []);


    const fetchUsers = async () => {
      setLoading(true);

      try {
        const response = await fetch(
           
          'https://api.dectwinhotel.com/api/get-all-users');

        setLoading(false);
        if (response.ok) {
          const data = await response.json();
console.log(data);
        setUsers(data);
        } else {
          setLoading(false);
          console.error('Failed to fetch users');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching users:', error);
      }
    };


const filteredUsers = users.filter((user) => {
  const matchesSearch =
    (user.business_name || '')
      .toLowerCase()
      .includes(searchQuery.toLowerCase()) ||
    (user.mobile || '')
      .toLowerCase()
      .includes(searchQuery.toLowerCase());

  const matchesStatus =
    acType === 'All'
      ? true
      : user.is_active == acType;

  return matchesSearch && matchesStatus;
});


const accountStatus = async (userId, is_active) => {
  const toastId = toast.loading('Updating account status...');

  try {
    const response = await fetch(
      `https://api.dectwinhotel.com/api/admin-update-status/${userId}`,
      {
        method: 'PUT',
            headers: {
  'Content-Type': 'application/json',
},
        body: JSON.stringify({
          is_active: is_active,
        })
      }
    );

    const data = await response.json();

    if (response.ok) {
      toast.success('Account status updated', {
        id: toastId,
      });

      fetchUsers();
      setShowModal(false);
    } else {
      toast.error(data.message || 'Failed to update status', {
        id: toastId,
      });
    }
  } catch (error) {
    console.error(error);

    toast.error('Something went wrong', {
      id: toastId,
    });
  }
};




  return (
    <>
      <section>

{!showModal && 
                <div className='container-fluid'>
                            <p className='sec-heading'>Manage Users</p>

<div className='d-md-flex d-sm-flex justify-content-between'>
<div className='d-flex bg-white rounded-4 mb-2 col-md-4'>
<i class="fa-solid fa-magnifying-glass text-darkblue py-3 px-3"></i>
                    <input
                    type="text"
                    className="support-input outline-0 border-0 rounded-end-4"
                    placeholder="Search User"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  </div>

             <select
  className="support-input border-0 outline-0 rounded-4 mb-2 col-md-2 col-sm-4 col-6"
  value={acType}
  onChange={(e) => setAcType(e.target.value)}
>
  <option value='All'>All</option>
  <option value='Yes'>Active</option>
  <option value='No'>Inactive</option>
</select>

</div>


<div className='table-responsive bg-white rounded-4 mt-3'>
    <table className='w-100'>
<tr>
    <th className='p-2'>S No</th>
    <th className='p-2'>Name</th>
    <th className='p-2'>Mobile No</th>
    <th className='p-2'>Password</th>
        <th className='p-2'>Hotel Id</th>
    <th className='p-2'>Created On</th>

    <th className='p-2'>Activity</th>
    </tr>

                            {filteredUsers.length > 0 ? (
              filteredUsers.map((myUser, index) => (
                <tr className='text-muted para-text fw-semibold' key={myUser.id} style={{ backgroundColor: index % 2 === 0 ? 'var(--grey2)' : 'white' }}>
                      <td className='p-2'>{index + 1}</td>
                      <td className='p-2'><span className={`px-2 py-1 ${myUser.is_active == 'No' && 'bg-danger text-white rounded-3'}`}>{myUser.business_name || 'NA'}</span></td>
                      <td className='p-2'>{myUser.contact || 'NA'}</td>
                      <td className='p-2'>{myUser.pass || 'NA'}</td>
                      <td className='p-2'>{myUser.hotel_id}

</td>         
<td className='p-2'>
  {myUser.subscription_on
    ? new Date(myUser.subscription_on).toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      })
    : 'NA'}
</td>          

 
            <td className='p-2 text-center fs-5 cursor-pointer' onClick={() => {setSelectedUser(myUser); setShowModal(true)}}><i class="fa-solid fa-pen-to-square"></i></td>
                      
                </tr>
              ))
            )

            : (
              <>
                <tr className='text-center'>
                  <td colSpan='7'>
                  {/* <img src={StaffImg1} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10 my-3' alt='Staff' /> */}
                  <p className='fw-semibold py-4'>{loading ? 'Loading...': 'No Users found.'}
</p>
                  </td>
                </tr>
              </>
            )}
    </table>
</div>


</div>
}

{showModal && 
<div className='container-fluid my-2'>

<div className='bg-white p-3 rounded-4'>


<div className='d-flex justify-content-between'>
                              <p className='sec-heading fs-5 my-0 text-capitalize'>{selectedUser.business_name ?? 'User'}
                                   <button className={`btn btn-sm w-auto ms-2 mb-2 ${selectedUser.is_active == 'No' ? 'btn-danger' : 'btn-success'}`}
   onClick={async () => {


          const result = await Swal.fire({
            title: `${selectedUser.is_active == 'No' ? 'Active' : 'Inactive'} Account?`,
            text: `${selectedUser.is_active == 'No' ? 'This account will get activated' : `User will lose access to the account & Software will not work`}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: `Yes, ${selectedUser.is_active == 'No' ? 'Active' : 'Inactive'}`,
          });

          if (result.isConfirmed) {
            accountStatus(
              selectedUser.id,
               selectedUser.is_active == "No" ? 'Yes' : "No"
            );
          }
        }}>Account {selectedUser.is_active == 'No' ? 'Inactive' : 'Active'}</button> 
                              </p>
<button className='btn btn-primary' onClick={() => {setSelectedUser(''); setShowModal(false)}}>Go back</button></div>
                               <span className='para-text fw-light'>Owner: {selectedUser.name ?? '-'}<br />Mobile No: {selectedUser.contact}<br />Email: {selectedUser.gmail ?? 'NA'}</span>



</div>
{/* flex ends */}
  <div className="row bg-white rounded-4 mt-3 p-2 m-0">

  {selectedUser.image != null &&
      <div className="col-md-12 mb-3 text-center">
  
  <img src={`${selectedUser.image}`} className='rounded-4' style={{height: '8em', width: '8em'}} />
  </div>}
 
 <div className="col-md-6 mb-2">
        <strong>Invoices Created:</strong> {selectedUser.inv_no - 1 || '1'}
      </div>

      <div className="col-md-6 mb-2">
        <strong>GST:</strong> {selectedUser.gstin || 'NA'}
      </div>

      <div className="col-md-6 mb-2">
        <strong>FSSAI No:</strong> {selectedUser.fssai || 'NA'}
      </div>


      <div className="col-md-6 mb-2">
        <strong>Acc Created:</strong>{' '}
        {selectedUser.subscription_on
          ? new Date(selectedUser.subscription_on).toLocaleString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            })
          : 'NA'}
      </div>
<hr className='my-3' />
      <div className="col-md-12 mb-2">
        <strong>Business Tagline:</strong> {selectedUser.tagline || 'NA'}
      </div>

      <div className="col-md-12 mb-2">
        <strong>Address:</strong> {selectedUser.address || 'NA'}
      </div>
 <div className="col-md-12 mb-2">
        <strong>Footer content:</strong> {selectedUser.footer_contents || 'NA'}
      </div>




</div>

</div>
}




</section>
    
    </>
  )
}

export default HotelUsers